module.exports = __webpack_public_path__ + "static/media/3-circle-available.42118820.svg";